// Accessibility helpers (AODA / WCAG 2.0 AA).

// Flickity moves carousel cells into its own wrapper divs, which breaks the <ul role="list"> structure. Describe
// each carousel as a labelled group, give Flickity's slider the list role, and let keyboard users move through it
// with the Previous / Next buttons (the carousel's own tab stop had no visible focus on the dark pages).
function fixCarousels() {
  document.querySelectorAll('.flickity-enabled').forEach((carousel) => {
    const slider = carousel.querySelector(':scope > .flickity-viewport > .flickity-slider');
    if (!slider || carousel.closest('[aria-hidden="true"]')) return;

    carousel.setAttribute('role', 'group');
    carousel.setAttribute('aria-roledescription', 'carousel');
    if (!carousel.hasAttribute('aria-label')) carousel.setAttribute('aria-label', 'Image carousel');
    if (carousel.matches('ul, ol')) slider.setAttribute('role', 'list');
    if (carousel.querySelector(':scope > .flickity-prev-next-button')) carousel.removeAttribute('tabindex');
  });
}

// Pause / play buttons for the looping background videos on the case study pages. With "reduce motion" turned on,
// the videos start paused.
function initVideoToggles() {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-video-toggle]').forEach((button) => {
    const video = button.parentElement.querySelector('video');
    if (!video) return;

    const update = () => {
      button.classList.toggle('is-paused', video.paused);
      button.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
    };

    button.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
    video.addEventListener('play', update);
    video.addEventListener('pause', update);

    if (reduceMotion) {
      video.removeAttribute('autoplay');
      video.pause();
      update();
    }
  });
}

// The map pins pulse twice (about 4 seconds) once the map scrolls into view, instead of forever.
function initMapPulse() {
  if (!('IntersectionObserver' in window)) return;

  document.querySelectorAll('.media').forEach((media) => {
    if (!media.querySelector(':scope > .map_location')) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        media.classList.add('map-pulse-active');
      },
      { threshold: 0.5 }
    );
    observer.observe(media);
  });
}

fixCarousels();
initVideoToggles();
initMapPulse();
